// extracted by mini-css-extract-plugin
export var container = "_bv-1";
export var cornerButtonContainer = "_bv-6";
export var disabled = "_bv-2";
export var dragActive = "_bv-3";
export var fileContainer = "_bv-5";
export var hiddenInput = "_bv-4";
export var widthContainer = "_bv-0";